import React, { ChangeEvent, useEffect, useState } from "react"
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer"
import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  Typography,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import DataService from "../../../../../Service"
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions"
import { useDispatch } from "react-redux"
import CloseIcon from "@material-ui/icons/Close"

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
  organizationFilter: {
    width: 400,
    marginTop: "70px",
    padding: "10px",
  },
  organizationFormTitle: {
    display: "flex",
    alignItems: "center",
  },
})

interface ICurrentSelection {
  description: string
  id: any
  max_duration: string
  measure: string
  min_duration: string
  organisations: Array<[{ id: number; organisation_name: string }]>
}

interface IProps {
  parentCall: any
  currentSelection: ICurrentSelection
}

interface IOrganisation {
  id: number
  organisation_name: string
}

interface IFetchAPIResponse {
  organisations: Array<[IOrganisation]>
  success: boolean
}

const OrganisationDrawer: React.FC<IProps> = (props: IProps) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { parentCall, currentSelection } = props

  const [data, setData] = useState<any>([])
  const [drawerFlag, setDrawerFlag] = useState<any>({ drawerFlag: false })

  const toggleDrawer = (anchor: string, open: boolean) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }
    setDrawerFlag(open)
    !open && parentCall(false)
  }

  useEffect(() => {
    fetchOrganisation()
  }, [])

  const fetchOrganisation = () => {
    let params = {
      SLA_id: currentSelection?.id,
    }
    DataService.getData(params, `fetch_Organisations`)
      .then((res: { success: boolean; organisations: any }) => {
        if (res?.["success"]) {
          setData(res?.organisations)
        }
      })
      .catch((error) => {})
  }

  const handleChange = (
    e: ChangeEvent<HTMLInputElement>,
    organisation: any
  ) => {
    const localArr = data.map(
      (option: {
        active: boolean
        organisation_name: string
        id: string | number
      }) => {
        if (organisation?.id == option?.id) {
          option["active"] = e.target.checked
        }
        return option
      }
    )
    setData(localArr)

    const formData: any = new FormData()
    formData.append("organisations_id[]", organisation?.id)
    formData.append("SLA_id", currentSelection?.id)

    DataService.createData(formData, "select_organisation_for_SLA")
      .then((res) => {
        if (res?.success) {
          dispatch(showSnackbar("Success", ["" + res.message], 5000))
        }
      })
      .then((error) => {})
  }

  const list = (anchor: any) => (
    <Box m={3} className={classes.organizationFilter}>
      <Box style={{ position: "absolute", right: 30 }}>
        <CloseIcon
          onClick={() => parentCall(false)}
          style={{ fontSize: 18, cursor: "pointer" }}
        />
      </Box>
      <Typography
        variant="subtitle1"
        style={{ marginBottom: 15, fontSize: "18px", fontFamily: "Open Sans" }}
      >
        <Box fontWeight="fontWeightBold">SLA</Box>
      </Typography>
      <FormControl
        component="fieldset"
        style={{ display: "flex", fontSize: "16px", fontFamily: "Open Sans" }}
      >
        <FormGroup>
          {data.map((option: any) => {
            return (
              <Box>
                <Grid container spacing={2}>
                  <Grid className={classes.organizationFormTitle} item xs={9}>
                    <label>{option.organisation_name}</label>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControlLabel
                      label={""}
                      style={{ alignSelf: "flex-end" }}
                      control={
                        <Switch
                          checked={option.active}
                          onChange={(e) => handleChange(e, option)}
                          name={option.organisation_name}
                        />
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            )
          })}
        </FormGroup>
      </FormControl>
    </Box>
  )

  return (
    <>
      <div>
        <React.Fragment>
          <SwipeableDrawer
            anchor={"right"}
            open={drawerFlag}
            onClose={toggleDrawer("drawerFlag", false)}
            onOpen={toggleDrawer("drawerFlag", true)}
          >
            {list("right")}
          </SwipeableDrawer>
        </React.Fragment>
      </div>
    </>
  )
}
export default OrganisationDrawer
